import { cva, type VariantProps } from 'class-variance-authority';

export const gridImageVariants = cva(
  'flex-shrink-0 max-w-grid-image max-h-grid-image flex',
  {
    variants: {
      padding: {
        none: 'p-0',
        default: 'p-md',
      },
    },
    defaultVariants: {
      padding: 'default',
    },
  },
);

export type GridImageVariantProps = VariantProps<typeof gridImageVariants>;
